import React from 'react';
import PropTypes from 'prop-types';

import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { t } from 'i18next';
import { ErrorOutline } from '@mui/icons-material';
import styles from './styles';

const Alert = React.forwardRef((props, ref) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

const AlertMessageRaw = ({
  className, alertMessage, openAlert, alertSeverity, closeAlert, alertTitle,
  snackbarProps,
}) => {
  const isValidComponent = React.isValidElement(alertMessage);

  return (
    <Snackbar
      className={className}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={openAlert}
      onClose={closeAlert}
      {...snackbarProps}
    >
      <Alert
        severity={alertSeverity}
        onClose={closeAlert}
        iconMapping={{ warning: <ErrorOutline fontSize="inherit" /> }}
      >
        {isValidComponent && alertMessage}
        {
          !isValidComponent && typeof (alertMessage) !== 'string' && (
            <>
              {alertTitle && alertTitle !== '' && <Typography>{t(alertTitle)}</Typography>}
              <Typography>
                {t(alertMessage.message)}
              </Typography>
              {
                alertMessage.details
                && React.Children.toArray(alertMessage.details.map((el) => (
                  <Typography>
                    {t(el)}
                  </Typography>
                )))
              }
            </>
          )
        }
        {
          !isValidComponent && typeof (alertMessage) === 'string' && (
            <>
              {alertTitle && alertTitle !== '' && (
                <>
                  <strong>{t(alertTitle)}</strong>
                  <br />
                </>
              )}
              {t(alertMessage)}
            </>
          )
        }
      </Alert>
    </Snackbar>
  );
};

AlertMessageRaw.propTypes = {
  className: PropTypes.string,
  openAlert: PropTypes.bool.isRequired,
  closeAlert: PropTypes.func.isRequired,
  alertMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node,
  ]).isRequired,
  alertSeverity: PropTypes.string.isRequired,
  alertTitle: PropTypes.string,
};

const AlertMessage = styled(AlertMessageRaw)(styles);

AlertMessage.propTypes = AlertMessageRaw.propTypes;

export default AlertMessage;
